import { useEffect, useState } from "react";
import TrackViewBarChart from "./TrackViewBarChart";
import PivotableBarChart from "./PivotableBarChart";

function GWPTotalChart({ selectedRows, showHeader = false }) {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "GWP Total (kg CO₂e)",
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      },
    ],
  });
  const [averageGWP, setAverageGWP] = useState(0.0);
  const [totalGWP, setTotalGWP] = useState(0.0);
  const predefinedColors = [
    "rgba(34, 139, 34, 0.6)",
    "rgba(60, 179, 113, 0.6)",
    "rgba(50, 205, 50, 0.6)",
    "rgba(0, 128, 0, 0.6)",
    "rgba(144, 238, 144, 0.6)",
    "rgba(46, 139, 87, 0.6)",
    "rgba(154, 205, 50, 0.6)",
    "rgba(85, 107, 47, 0.6)",
    "rgba(34, 177, 76, 0.6)",
    "rgba(60, 179, 113, 0.6)",
  ];
  const predefinedBorderColors = predefinedColors.map((color) => color.replace("0.6", "1"));

  useEffect(() => {
    const labels = selectedRows.map((row) => row.name || row.name || row.organization);
    const gwpData = selectedRows.map((row) => row.gwp);
    const colors = predefinedColors.slice(0, selectedRows.length);
    const borderColors = predefinedBorderColors.slice(0, selectedRows.length);

    let multipliedGwpData = gwpData.map((value, index) => {
      if (selectedRows[index].quantity === undefined) {
        return value;
      }
      return (value * selectedRows[index].quantity).toFixed(2);
    });
    const adjustDatasetCount = (labels, data, backgroundColors, borderColors) => {
      const minBars = 4;
      const currentCount = labels.length;
      if (currentCount < minBars) {
        const missingBars = minBars - currentCount;
        for (let i = 0; i < missingBars; i++) {
          labels.push("");
          data.push(0);
          backgroundColors.push("transparent");
          borderColors.push("transparent");
        }
      }
      return { labels, data, backgroundColors, borderColors };
    };
    const adjustedData = adjustDatasetCount(labels, multipliedGwpData, colors, borderColors);
    setTotalGWP(multipliedGwpData.reduce((acc, value) => acc + parseFloat(value), 0));
    setChartData({
      labels: adjustedData.labels,
      datasets: [
        {
          label: "GWP Total (kg CO₂e)",
          data: adjustedData.data,
          backgroundColor: adjustedData.backgroundColors,
          borderColor: adjustedData.borderColors,
          borderWidth: 1,
        },
      ],
    });
  }, [selectedRows]);
  useEffect(() => {
    if (selectedRows.length === 0) {
      setTotalGWP(0.0);
      setAverageGWP(0.0);
      return;
    }
    setAverageGWP(totalGWP / selectedRows.length);
  }, [totalGWP, selectedRows]);
  return (
    <PivotableBarChart
      title={showHeader ? "GWP (kg CO₂e)" : undefined}
      usages={selectedRows}
      groupBy={"name"}
      countBy={"gwp"}
      isLogarithm
      xAxisLabel="GWP (kg CO₂e)"
      titleFontWeight={500}
      showTitleDivider={showHeader}
    />
    // <TrackViewBarChart
    //   data={chartData}
    //   filename={"gwp_total_graph"}
    //   totalValue={totalGWP}
    //   title={"GWP (kg CO₂e)"}
    //   averageValue={averageGWP}
    //   totalLabel={"Total GWP: "}
    //   averageLabel={"Average GWP: "}
    //   unit={"kg CO₂e"}
    // />
  );
}

export default GWPTotalChart;
